'use strict';

require("core-js/modules/es6.regexp.replace");

module.exports = trimTrailingLines; // Remove final newline characters from `value`.

function trimTrailingLines(value) {
  return String(value).replace(/\n+$/, '');
}